import useGetFamilies from '../../hooks/useGetFamilies';
import DropDown from '../Dropdown';
import { FamiliesDropdownContainer } from './styles';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

function FamiliesDropdown({ setDataFunc, familyId, setFamilyAccess, isDisabled }) {
  const { families, isLoading } = useGetFamilies(setFamilyAccess);
  const errorMsg = 'No additional module families could be loaded!';
  let location = useLocation();

  const familiesToShow = useMemo(
    () =>
      !families
        ? []
        : families.map((family) => ({
            value: family.id,
            label: `${family.code} - ${family.name}`,
          })),
    [families]
  );

  useEffect(() => {
    if (!families) return;

    if (location.pathname === `/catalog/idcard/new/create`) {
      if (families.length < 1) {
        setFamilyAccess(false);
        return;
      }
      setDataFunc({
        family: `${families[0].code} - ${families[0].name}`,
        familyId: families[0].id,
        characteristics: families[0].characteristics,
        characteristicsLabel: families[0].characteristicsLabel,
      });
    } else if (['catalog', 'idcard', 'edit'].every((part) => location.pathname.includes(part))) {
      // quick fix
      // its edit screen
      let familyObj = families.find((family) => family.id === familyId);
      if (familyObj) {
        setDataFunc({
          characteristicsLabel: familyObj.characteristicsLabel,
        });
      }
    }
  }, [families]);

  const onChange = (option) => {
    const chosenFamilyObj = families.find((family) => family.id === option.value);
    setDataFunc({
      family: chosenFamilyObj.name,
      familyId: chosenFamilyObj.id,
      characteristics: chosenFamilyObj.characteristics,
      characteristicsLabel: chosenFamilyObj.characteristicsLabel,
    });
  };

  return (
    <FamiliesDropdownContainer>
      <DropDown
        isLoading={isLoading}
        options={familiesToShow}
        value={familyId}
        onChange={onChange}
        placeholder='Select Family'
        isDisabled={isDisabled}
      />
    </FamiliesDropdownContainer>
  );
}

export default FamiliesDropdown;
